import "../_namespaces.js";
import "#/shared/api/api-host-global.js";
import "../../../shared/client/jst.js";
import "../../../utilities/request_locale.js";
import "./address_selector.js";
import "./slot_list.js";
import "../../../shared/components/tooltips.js";
import "../../../shared/events.js";

window.AppointmentBooking ??= {};
window.AppointmentBooking.ProviderWidget ??= {};
window.AppointmentBooking.ProviderWidget.Views ??= {};

AppointmentBooking.ProviderWidget.Views.Widget = class Widget extends Backbone.View {
  constructor() {
    super(...arguments);
    this.initialize = this.initialize.bind(this);
    this.handleSelectedAddressChange = this.handleSelectedAddressChange.bind(this);
    this.render = this.render.bind(this);
    this.getSummary = this.getSummary.bind(this);
    this.teaserButtonText = this.teaserButtonText.bind(this);
    this.titleText = this.titleText.bind(this);
    this.selectedSchedulingOptions = this.selectedSchedulingOptions.bind(this);
    this.hasActionableContent = this.hasActionableContent.bind(this);
    this.hasSchedulingDisplayContent = this.hasSchedulingDisplayContent.bind(this);
    this.hasWalkInDisplayContent = this.hasWalkInDisplayContent.bind(this);
    this.keepWidgetWhenAnyAddressHasDisplayContent = this.keepWidgetWhenAnyAddressHasDisplayContent.bind(this);
    this.addressHasDisplayContent = this.addressHasDisplayContent.bind(this);
    this.selectedAddressHasDisplayContent = this.selectedAddressHasDisplayContent.bind(this);
    this.anyAddressHasDisplayContent = this.anyAddressHasDisplayContent.bind(this);
    this.allAddressesHaveDisplayContent = this.allAddressesHaveDisplayContent.bind(this);
    this.addressDisplayContentIsMixed = this.addressDisplayContentIsMixed.bind(this);
    this.refreshMobileCTA = this.refreshMobileCTA.bind(this);
    this.makeSelectedAddress = this.makeSelectedAddress.bind(this);
    this.initializeSelectedPatientType = this.initializeSelectedPatientType.bind(this);
    this.getPatientTypeFromParams = this.getPatientTypeFromParams.bind(this);
    this.defaultPatientTypeForSelectedAddress = this.defaultPatientTypeForSelectedAddress.bind(this);
    this.getUrlBarAddressId = this.getUrlBarAddressId.bind(this);
    this.getUrlBarPatientType = this.getUrlBarPatientType.bind(this);
    this.openAppointmentModalRequested = this.openAppointmentModalRequested.bind(this);
    this.getUrlBarParams = this.getUrlBarParams.bind(this);
    this.setUrlBarAddressId = this.setUrlBarAddressId.bind(this);
    this.setUrlBarPatientType = this.setUrlBarPatientType.bind(this);
    this.setUrlBarParams = this.setUrlBarParams.bind(this);
    this.setSelectedPatientType = this.setSelectedPatientType.bind(this);
    this.fetchData = this.fetchData.bind(this);
    this.I18n = this.I18n.bind(this);
  }

  /*
  @param options Options hash
  @option options.apiParams          Request params included in the request to the provider metadata endpoint
  */
  initialize(options = {}) {
    this.options = options;
    this.model.set("provider", new Backbone.Model());
    this.model.set("selectedAddress", new Backbone.Model());
    this.model.set("addresses", new Backbone.Collection());

    this.locationView = new AppointmentBooking.ProviderWidget.Views.AddressSelector({ model: this.model });
    this.patientTypeView = new AppointmentBooking.ProviderWidget.Views.PatientTypeSelector({ model: this.model });
    this.slotListView = new AppointmentBooking.ProviderWidget.Views.SlotList({ model: this.model });

    this.fetchData().then((provider) => {
      this.model.get("provider").set(provider);
      const addresses = this.model.get("addresses");
      addresses.reset(provider.addresses);
      this.makeSelectedAddress(addresses.get(this.getUrlBarAddressId()) || addresses.first());
      this.initializeSelectedPatientType();

      this.trigger("ready");
      if (this.openAppointmentModalRequested()) {
        return this.slotListView.openAppointmentModal();
      }
    });

    // BEHAVIOUR

    this.listenTo(this.model.get("selectedAddress"), "change", this.handleSelectedAddressChange);
    return this.listenTo(this.model, "change:selectedPatientType", this.render);
  }

  // EVENT HANDLERS
  addTooltip(event) {
    return Sparkle.Tooltips.add(event.target, null, {
      theme: "white",
    });
  }

  handleAddressSelected(event, id) {
    this.makeSelectedAddress(this.model.get("addresses").get(id));
    // Only persist the address to the URL on an explicit user selection, not for the
    // default address picked on load, so the server-chosen primary (closest) address
    // isn't overridden by an address_id appearing after the page loads.
    if (this.model.get("addresses").length > 1) {
      this.setUrlBarAddressId(id);
    }
  }

  handlePatientSelected(event, value) {
    this.setUrlBarPatientType(value);
    return this.setSelectedPatientType(value);
  }

  handleSelectedAddressChange(event) {
    return this.render();
  }

  // RENDERING

  render() {
    const addresses = this.model.get("addresses");
    let schedulingOptions = this.selectedSchedulingOptions() || {};
    const keepWidgetWhenAnyAddressHasDisplayContent = this.keepWidgetWhenAnyAddressHasDisplayContent();
    const addressDisplayContentIsMixed =
      keepWidgetWhenAnyAddressHasDisplayContent && this.addressDisplayContentIsMixed();

    const showSelectedAddressContent =
      !keepWidgetWhenAnyAddressHasDisplayContent || this.selectedAddressHasDisplayContent();
    const showWidget =
      addresses.length > 0 && (!keepWidgetWhenAnyAddressHasDisplayContent || this.anyAddressHasDisplayContent());

    this.$el.toggle(showWidget);
    this.$el.toggleClass(
      "provider-appointment-widget--mixed-address-content",
      showWidget && addressDisplayContentIsMixed,
    );

    if (showWidget) {
      const componentVariant = this.model.get("provider").get("component_variant") || "primary";
      this.$el.attr("data-cta", componentVariant);

      // Disable mobile CTA for display-only widgets
      if (this.hasActionableContent(schedulingOptions)) {
        this.$el.removeAttr("mobile-cta-disabled");
      } else {
        this.$el.attr("mobile-cta-disabled", true);
      }

      this.$el.attr("data-cta-teaser-button-text", this.teaserButtonText());
      this.$el.html(window.Sparkle.Client.jstTemplate(this.template)({ title: this.titleText(), I18n: this.I18n() }));

      this.locationView.setElement(this.$el.find(".location")[0]);
      this.patientTypeView.setElement(this.$el.find(".patient-type")[0]);
      this.slotListView.setElement(this.$el.find(".slots")[0]);

      const showAddressSelector = addresses.length > 1;
      const showPatientTypeSelector = _.every(addresses.models, (address) => {
        schedulingOptions = address.get("scheduling");

        // Always hide the patient type selector if scheduling is missing, or one of the scheduling patient types is hidden
        if (
          _.isEmpty(schedulingOptions) ||
          _.isUndefined(schedulingOptions.new_patient) ||
          _.isUndefined(schedulingOptions.returning_patient)
        ) {
          return false;
        }

        // Always show the patient type selector if sparkle scheduling is enabled
        if (
          schedulingOptions.new_patient.type === "sparkle" ||
          schedulingOptions.returning_patient.type === "sparkle"
        ) {
          return true;
        }

        return !_.isEqual(
          _.omit(schedulingOptions.new_patient, "priority"),
          _.omit(schedulingOptions.returning_patient, "priority"),
        );
      });

      this.locationView.$el.toggle(showAddressSelector);
      this.patientTypeView.$el.toggle(showSelectedAddressContent && showPatientTypeSelector);
      this.slotListView.$el.toggle(showSelectedAddressContent);
      this.$el.toggle(showWidget);

      this.locationView.render();
      this.patientTypeView.render();
      if (showSelectedAddressContent) {
        this.slotListView.render(); // call render after the widget is visible because slotListView relies on a text element's width.
      } else {
        this.slotListView.$el.html("");
      }
    } else {
      this.$el.removeAttr("data-cta data-cta-teaser-button-text mobile-cta-disabled");
      this.$el.html("");
    }

    if (keepWidgetWhenAnyAddressHasDisplayContent && jQuery.contains(document.documentElement, this.el)) {
      if (this.hasRenderedAttached) {
        this.refreshMobileCTA();
      } else {
        this.hasRenderedAttached = true;
      }
    }

    Sparkle.Events.contentUpdated(this.el);

    return this;
  }

  // DSL

  getSummary() {
    const addresses = this.model.get("addresses");
    const bothPatientAddresses = addresses.filter(
      (address) =>
        address.get("scheduling")?.returning_patient?.slots?.length &&
        address.get("scheduling")?.new_patient?.slots?.length,
    );
    const newPatientAddresses = addresses.filter(
      (address) =>
        address.get("scheduling")?.new_patient?.slots?.length &&
        !address.get("scheduling")?.returning_patient?.slots?.length,
    );
    const returningPatientAddresses = addresses.filter(
      (address) =>
        address.get("scheduling")?.returning_patient?.slots?.length &&
        !address.get("scheduling")?.new_patient?.slots?.length,
    );

    const output = [];
    if (bothPatientAddresses.length) {
      output.push(`${this.pluralizeAddress(bothPatientAddresses.length)} with both new and returning patient visits`);
    }
    if (newPatientAddresses.length) {
      output.push(`${this.pluralizeAddress(newPatientAddresses.length)} with new patient visits`);
    }
    if (returningPatientAddresses.length) {
      output.push(`${this.pluralizeAddress(returningPatientAddresses.length)} with returning patient visits`);
    }

    if (output.length) {
      return `Scheduler is showing ${output.join(", ")}.`;
    } else {
      return "Scheduler is showing but no appointments are available.";
    }
  }

  // PRIVATE

  teaserButtonText() {
    return this.selectedSchedulingOptions()?.cta_teaser_button_text || this.I18n().cta_teaser_button_text;
  }

  titleText() {
    return this.selectedSchedulingOptions()?.title || this.I18n().title;
  }

  selectedSchedulingOptions() {
    const selectedPatientType = this.model.get("selectedPatientType");
    let schedulingOptions = this.model.get("selectedAddress").get("scheduling") || {};
    schedulingOptions = schedulingOptions[selectedPatientType] || {};

    return schedulingOptions;
  }

  hasActionableContent(schedulingOptions) {
    return schedulingOptions.slots?.length || schedulingOptions.url != null;
  }

  hasSchedulingDisplayContent(schedulingOptions) {
    return (
      this.hasActionableContent(schedulingOptions) ||
      schedulingOptions.message != null ||
      schedulingOptions.booking_number_message != null
    );
  }

  hasWalkInDisplayContent(walkInOptions) {
    return walkInOptions.message != null || walkInOptions.disclaimer != null || walkInOptions.tooltip != null;
  }

  keepWidgetWhenAnyAddressHasDisplayContent() {
    return this.model.get("provider").get("keep_widget_when_any_address_has_display_content");
  }

  addressHasDisplayContent(address) {
    const schedulingOptions = address?.get("scheduling") || {};
    const walkInOptions = address?.get("walk_in") || {};

    return (
      this.hasWalkInDisplayContent(walkInOptions) ||
      _.some(schedulingOptions, (options) => this.hasSchedulingDisplayContent(options || {}))
    );
  }

  selectedAddressHasDisplayContent() {
    return this.addressHasDisplayContent(this.model.get("selectedAddress"));
  }

  anyAddressHasDisplayContent() {
    return _.some(this.model.get("addresses").models, (address) => this.addressHasDisplayContent(address));
  }

  allAddressesHaveDisplayContent() {
    return _.every(this.model.get("addresses").models, (address) => this.addressHasDisplayContent(address));
  }

  addressDisplayContentIsMixed() {
    return this.anyAddressHasDisplayContent() && !this.allAddressesHaveDisplayContent();
  }

  refreshMobileCTA() {
    if (window.Sparkle?.MobileCTA?.renderModalTeaser == null) {
      return;
    }

    // Mirrors the mobile CTA loader after the async provider widget changes its CTA state.
    const components = jQuery("[data-cta]");
    const disabled = components.filter("[mobile-cta-disabled]").add(components.has("[mobile-cta-disabled]"));
    const spComponentsCTAs = components.has("[mobile-cta-target]");
    const modalCTAs = components.not(".cta_style_teaser").not(spComponentsCTAs).not(disabled).slice(0, 2);

    Sparkle.MobileCTA.renderModalTeaser(modalCTAs, "[data-sparkle-container]", true);
  }

  pluralizeAddress(count) {
    return `${count} address${count === 1 ? "" : "es"}`;
  }

  makeSelectedAddress(address) {
    const selectedAddress = this.model.get("selectedAddress");
    selectedAddress.clear();
    if (address) {
      return selectedAddress.set(address.attributes);
    }
  }

  initializeSelectedPatientType() {
    let patientType;
    const patientTypeFromUrl = this.getPatientTypeFromParams();
    if (this.patientTypeView.isValidPatientType(patientTypeFromUrl)) {
      patientType = patientTypeFromUrl;
    }
    if (!patientType) {
      patientType = this.defaultPatientTypeForSelectedAddress();
    }

    this.setUrlBarPatientType(patientType);
    return this.setSelectedPatientType(patientType);
  }

  getPatientTypeFromParams() {
    let patientType = this.getUrlBarPatientType();
    if (!patientType) {
      patientType = (() => {
        switch (this.getUrlBarParams("new_patient")) {
          case "false":
            return "returning_patient";
          case "true":
            return "new_patient";
        }
      })();
    }

    return patientType;
  }

  defaultPatientTypeForSelectedAddress() {
    const selectedAddress = this.model.get("selectedAddress");
    const { scheduling } = selectedAddress.attributes;
    if (_.isEmpty(scheduling)) {
      return;
    }

    return _.min(Object.keys(scheduling), (key) => scheduling[key].priority);
  }

  getUrlBarAddressId() {
    return this.getUrlBarParams("address_id");
  }

  getUrlBarPatientType() {
    return this.getUrlBarParams("patient_type");
  }

  // `open_schedule` on the page URL is the campaign-link switch for the full-schedule modal.
  // Any value other than `false` counts, including a bare `?open_schedule`.
  openAppointmentModalRequested() {
    const value = this.getUrlBarParams("open_schedule");
    return value != null && value !== "false";
  }

  getUrlBarParams(paramName) {
    if (!window.URL) {
      return;
    }

    return new URL(window.location).searchParams.get(paramName);
  }

  setUrlBarAddressId(addressId) {
    return this.setUrlBarParams("address_id", addressId);
  }

  setUrlBarPatientType(patientType) {
    return this.setUrlBarParams("patient_type", patientType);
  }

  setUrlBarParams(key, value) {
    if (!window.URL) {
      return;
    }

    try {
      const url = new URL(window.location);
      url.searchParams.set(key, value);
      return window.history.replaceState(null, "", url.toString());
    } catch (e) {
      // Silently fail in srcdoc iframes where history.replaceState throws SecurityError
      return;
    }
  }

  setSelectedPatientType(patientType) {
    return this.model.set("selectedPatientType", patientType);
  }

  fetchData() {
    const endpoint = this.metadataEndpoint[this.model.get("providerType")];
    // Forward the page locale so the widget's scheduling messages and dates are
    // served in the visitor's language. A request without one is served in the
    // default locale.
    const params = jQuery.extend({}, this.options.apiParams);
    const locale = Sparkle.Utilities.requestLocale();
    if (locale) {
      params.locale = locale;
    }
    return jQuery.getJSON(endpoint.replace("%{providerId}", this.model.get("providerId")), params);
  }

  I18n() {
    return AppointmentBooking.config.i18n.provider_widget;
  }
};
AppointmentBooking.ProviderWidget.Views.Widget.prototype.tagName = "section";
AppointmentBooking.ProviderWidget.Views.Widget.prototype.className = "provider-appointment-widget component";
AppointmentBooking.ProviderWidget.Views.Widget.prototype.template =
  "appointment_booking/provider_widget/templates/widget";

AppointmentBooking.ProviderWidget.Views.Widget.prototype.metadataEndpoint = {
  Physician: window.Sparkle.apiHost
    ? window.Sparkle.apiHost + window.SparkleConfig.routes.embed.physicianWidget.replace("PROVIDER_ID", "%{providerId}")
    : undefined,
  Location: window.Sparkle.apiHost
    ? window.Sparkle.apiHost + window.SparkleConfig.routes.embed.locationWidget.replace("PROVIDER_ID", "%{providerId}")
    : undefined,
};

AppointmentBooking.ProviderWidget.Views.Widget.prototype.events = {
  [AppointmentBooking.ProviderWidget.Events.AddressSelector.addressSelected]: "handleAddressSelected",
  [AppointmentBooking.ProviderWidget.Events.PatientTypeSelector.patientTypeSelected]: "handlePatientSelected",
  "mouseenter .section-appointments a[title]": "addTooltip",
};
